import { Dialog } from "./dialog";
import { StandardFrame } from "../frames/standard-frame";
import { SimpleButton } from "../buttons/simple-button";
import { MAX_DAILY_REWARDED_DUELS } from "types/duels/types";

interface RewardsInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RewardsInfoDialog = ({
  isOpen,
  onClose,
}: RewardsInfoDialogProps) => {
  if (!isOpen) return null;

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div className="px-2 mx-auto min-w-[40vw]">
        <StandardFrame variant="gold" className="max-w-md w-full">
          <div className="text-center mt-3">
            <h2 className="text-xl font-bold text-pk-white mb-1">
              PVP DUEL REWARDS
            </h2>
            <p className="text-pk-beige-5 mb-4 text-xs">
              Daily reward system for competitive play
            </p>

            <div className="text-left space-y-3 mb-6">
              <div className="bg-pk-yellow-1/20 rounded-lg p-3 border border-pk-yellow-3/30">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">💰</span>
                  <h3 className="text-sm font-bold text-pk-white">REWARDS</h3>
                </div>
                <p className="text-pk-beige-5 text-xs leading-relaxed">
                  Earn{" "}
                  <span className="text-pk-yellow-3 font-bold">PokéCoins</span>{" "}
                  and{" "}
                  <span className="text-pk-blue-5 font-bold">PokéShards</span>{" "}
                  for your first{" "}
                  <span className="text-pk-green-5 font-bold">
                    {MAX_DAILY_REWARDED_DUELS} duels
                  </span>{" "}
                  each day. Higher rewards for winning matches!
                </p>
              </div>

              <div className="bg-pk-yellow-1/20 rounded-lg p-3 border border-pk-yellow-3/30">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">🏆</span>
                  <h3 className="text-sm font-bold text-pk-white">
                    UNLIMITED PLAY
                  </h3>
                </div>
                <p className="text-pk-beige-5 text-xs leading-relaxed">
                  Play as many duels as you want! Additional duels beyond{" "}
                  {MAX_DAILY_REWARDED_DUELS} still affect your{" "}
                  <span className="text-pk-gold-4 font-bold">ELO rating</span>{" "}
                  and provide valuable experience.
                </p>
              </div>

              <div className="bg-pk-yellow-1/20 rounded-lg p-3 border border-pk-yellow-3/30">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">🔄</span>
                  <h3 className="text-sm font-bold text-pk-white">
                    DAILY RESET
                  </h3>
                </div>
                <p className="text-pk-beige-5 text-xs leading-relaxed">
                  Your reward counter resets every{" "}
                  <span className="text-pk-orange-5 font-bold">24 hours</span>{" "}
                  at{" "}
                  <span className="text-pk-orange-5 font-bold">00:00 UTC</span>.
                </p>
              </div>
            </div>

            <div className="flex justify-center">
              <SimpleButton
                onClick={onClose}
                className="px-6 py-1.5 text-sm font-bold"
                variant="yellow"
              >
                GOT IT!
              </SimpleButton>
            </div>
          </div>
        </StandardFrame>
      </div>
    </Dialog>
  );
};
